import { ResultsTable, ResultsHeaderRow, ResultsHeaderColumn } from './ProductSearchResults.styles';
import ProductSearchResultsList from '../ProductSearchResultsList/ProductSearchResultsList';

const ProductSearchResults = ({ productSearchResultList }) => {
  return (
    <>
      <ResultsTable>
        <ResultsHeaderRow>
          <ResultsHeaderColumn width="20%">ITEM</ResultsHeaderColumn>
          <ResultsHeaderColumn width="60%">ITEM NAME</ResultsHeaderColumn>
          <ResultsHeaderColumn width="20%">SKU</ResultsHeaderColumn>
        </ResultsHeaderRow>
        <ProductSearchResultsList productSearchResultList={productSearchResultList} />
      </ResultsTable>
    </>
  );
};

export default ProductSearchResults;
